import React, { useEffect, useState } from "react";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { useCookieConsent } from "../../context/CookieConsentProvider";
import { isPrerender } from "../../utils/isPrerender";

export default function CookieConsentBanner() {
  const {
    loaded,
    hasChoice,
    acceptAll,
    rejectAll,
    openPreferences,
    isPrefsOpen,
    closePreferences,
  } = useCookieConsent();

  const [hydrated, setHydrated] = useState(false);
  const [visible, setVisible] = useState(false); // ✅ add this

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated) return;

    const t = setTimeout(() => setVisible(true), 1500); // ✅ delay banner
    return () => clearTimeout(t);
  }, [hydrated]);

  // ✅ Never include banner/modal in react-snap HTML
  if (isPrerender()) return null;

  // ✅ Never show anything before real browser hydration
  if (!hydrated) return null;

  if (!loaded || hasChoice) {
    return <CookiePreferencesModal open={isPrefsOpen} onClose={closePreferences} />;
  }

  return (
    <>
      {visible && (
        <div className="fixed bottom-4 left-4 right-4 z-[9999]">
          <div className="mx-auto max-w-4xl rounded-2xl border border-pink-400/30 bg-[#11111f] p-5 shadow-xl">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div className="text-sm text-gray-200">
                <div className="text-base font-semibold text-pink-300">
                  We use cookies
                </div>
                <p className="mt-1 text-gray-300">
                  We use necessary cookies to keep the site secure. With your permission, we also use
                  analytics and marketing cookies to improve your experience. You can accept, reject,
                  or manage preferences any time.
                </p>
                <button
                  type="button"
                  onClick={openPreferences}
                  className="mt-2 text-pink-300 underline underline-offset-4 hover:text-pink-200"
                >
                  Manage preferences
                </button>
              </div>

              <div className="flex flex-col gap-2 md:min-w-[220px]">
                <button
                  type="button"
                  onClick={acceptAll}
                  className="w-full rounded-full bg-[#EB6AB5] px-4 py-2 font-semibold text-black hover:opacity-95"
                >
                  Accept all
                </button>
                <button
                  type="button"
                  onClick={rejectAll}
                  className="w-full rounded-full border border-pink-400/40 bg-transparent px-4 py-2 font-semibold text-pink-200 hover:bg-white/5"
                >
                  Reject all
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CookiePreferencesModal open={isPrefsOpen} onClose={closePreferences} />
    </>
  );
}